import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Pages/ErrorPage";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ErrorPageMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="ErrorPage">
      <MobileNotice page="ErrorPage" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default ErrorPageMobile;